























































































import mixins from 'vue-typed-mixins';
import { ReportNode, QuestionData, ReportContext } from '@/utils/ReportUtils';
import SurveyUtils, {
  Question,
  QuestionParticipation,
  Survey,
  SurveyParticipation,
} from '@/utils/SurveyUtils';
import questioncomponents from '../../questions';
import QuestionDocuments from '@/components/survey/questions/QuestionDocuments.vue';
import SurveyQuestionModal from '@/components/survey/management/questions/SurveyQuestionModal.vue';
import cloneDeep from 'lodash.clonedeep';
import deepEqual from 'deep-equal';
import { SubOrganization } from '@/utils/SubOrganizationUtils';
import SurveyNodeUtils from '@/utils/SurveyNodeUtils';
export default mixins().extend({
  components: {
    ...questioncomponents.components,
    QuestionDocuments,
    SurveyQuestionModal,
  },

  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },

    context: {
      type: Object as () => ReportContext,
    },

    suborganization: {
      type: Object as () => SubOrganization,
    },
  },

  computed: {
    type(): string | undefined {
      return this.value?.item?.questiontype?.key;
    },

    visible(): boolean {
      return this.value?.data?.visible || false;
    },

    editable(): boolean {
      return this.context.mode.includes('preview');
    },

    condition(): any {
      // NOTE: don't use this.value.data.conditional.visible for this as it shouldn't be changed unless the question is saved

      if (this.value.item?.condition?.key) {
        this.showConditionalText = false;

        const node = SurveyNodeUtils.getNode(
          this.context?.nodes as ReportNode[],
          (node: ReportNode) => {
            if (
              node.type === 'question' &&
              (node.item as Question).questionkey ===
                this.value.item?.condition?.key
            ) {
              return true;
            }
            return false;
          }
        ) as ReportNode<Question, QuestionData>;

        if (node) {
          let visible = false;
          if (node?.data?.participation?.answer?.value) {
            if (Array.isArray(node.data.participation?.answer?.value)) {
              visible = node.data.participation?.answer?.value?.some(
                (answer: any) =>
                  this.value.item?.condition?.answers?.includes(answer)
              );
            } else {
              visible =
                this.value.item?.condition?.answers?.includes(
                  node.data.participation?.answer?.value
                ) || false;
            }
          }

          if (visible) {
            return true;
          } else {
            return false;
          }
        } else if (
          this.context.mode.includes('worksheet') ||
          this.context.mode.includes('table')
        ) {
          // if the node wasn't found but this question is listed in a worksheet or a table it must still be visible
          this.showConditionalText = true; // display some text to show that the question is conditional
          return true;
        }
      } else {
        return true;
      }
    },
  },

  data(): {
    pristine?: QuestionParticipation;
    showHelp: boolean;
    showConditionalText: boolean;
  } {
    return {
      pristine: undefined,
      showHelp: false,
      showConditionalText: false,
    };
  },

  async mounted() {
    this.load();

    // scroll the screen to this question if it is in the URL
    const urlNode = SurveyNodeUtils.parsePathExact(
      this.context.path,
      this.context?.nodes || []
    );
    if (urlNode?.uuid === this.value.uuid) {
      (this.$refs.questiondiv as any).scrollIntoView();
    }
  },

  destroyed() {
    if (this.value) {
      this.value.data.participation = cloneDeep(this.pristine);
      this.value.data.dirty = false;
    }
  },

  watch: {
    suborganization(next, previous) {
      if (this.value && next !== previous) {
        this.load();
      }
    },
  },

  methods: {
    async load() {
      try {
        if (this.value) {
          this.loadConditional(); // async load conditional
          await SurveyNodeUtils.getParticipation(this.context, this.value, {
            suborganization: this.suborganization,
          });
          this.pristine = cloneDeep(this.value.data.participation);
        }
      } catch (error) {
        this.$alert.show('mount', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async loadConditional() {
      if (this.value.item?.condition?.key) {
        // find the node that contains the conditional question.
        const node = SurveyNodeUtils.getNode(
          this.context?.nodes as ReportNode[],
          (node: ReportNode) => {
            if (
              node.type === 'question' &&
              (node.item as Question).questionkey ===
                this.value.item?.condition?.key
            ) {
              return true;
            }
            return false;
          }
        ) as ReportNode<Question, QuestionData>;

        if (node) {
          let participation = node?.data?.participation;
          this.value.data.conditional.visible = undefined;

          // load node participation if it doesn't exist or if it is for the wrong suborganization
          if (
            !participation ||
            (node.item.orglevel === 'suborg' &&
              participation?.suborganization?.id !== this.suborganization?.id)
          ) {
            participation = await SurveyNodeUtils.getParticipation(
              this.context,
              node,
              {
                suborganization:
                  node.item.orglevel === 'suborg'
                    ? this.suborganization
                    : undefined,
              }
            );
          } else {
            participation = node.data.participation;
          }

          if (participation?.answer?.value) {
            if (Array.isArray(participation?.answer?.value)) {
              this.value.data.conditional.visible = participation?.answer?.value?.some(
                (answer: any) =>
                  this.value.item?.condition?.answers?.includes(answer)
              );
            } else {
              this.value.data.conditional.visible =
                this.value.item?.condition?.answers?.includes(
                  participation?.answer?.value
                ) || false;
            }
          } else {
            this.value.data.conditional.visible = false;
          }
        }
      }
    },

    async save() {
      if (this.value) {
        if (
          (this.$refs.component as any)?.before &&
          typeof (this.$refs.component as any).before === 'function'
        ) {
          await (this.$refs.component as any).before();
        }

        if (
          (this.value.data.dirty &&
            !deepEqual(this.value.data.participation, this.pristine)) ||
          !this.value.data.participation?.id
        ) {
          if (
            !this.context.mode.includes('preview') &&
            this.value.data.participation
          ) {
            if (this.value.data.participation?.id) {
              await SurveyUtils.api.questionParticipation.update(
                this.value.data.participation
              );
            } else {
              const resp = await SurveyUtils.api.questionParticipation.add([
                this.value.data.participation,
              ]);
              this.value.data.participation.id = resp[0];
            }
          }
          this.pristine = cloneDeep(this.value.data.participation);
        }

        if (
          (this.$refs.component as any)?.after &&
          typeof (this.$refs.component as any).after === 'function'
        ) {
          await (this.$refs.component as any).after();
        }

        this.value.data.dirty = false;
      }
    },

    handleEdit() {
      (this.$refs.edit as any).open(this.value?.item);
    },

    handleHelp() {
      this.showHelp = !this.showHelp;
    },

    handleAttachment() {
      //
    },

    async submitEdit(item: any) {
      if (
        this.value &&
        this.context.mode.includes('preview') &&
        this.value.data.participation
      ) {
        this.$alert.hide('submitEdit');
        await SurveyUtils.api.question.update(item);
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.default', {
            values: [item?.questionkey],
          }),
        });
      }

      if (this.value) {
        this.value.item = item;
      }
    },
  },
});
